import validate from "/baserow/web-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import authentication from "/baserow/web-frontend/modules/core/middleware/authentication.js";
import enterpriseExtraClientScripts from "/baserow/enterprise/web-frontend/modules/baserow_enterprise/middleware/extraClientScripts.js";
import manifest_45route_45rule from "/baserow/web-frontend/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  authentication,
  enterpriseExtraClientScripts,
  manifest_45route_45rule
]
export const namedMiddleware = {
  settings: () => import("/baserow/web-frontend/modules/core/middleware/settings.js"),
  authenticated: () => import("/baserow/web-frontend/modules/core/middleware/authenticated.js"),
  workspacesAndApplications: () => import("/baserow/web-frontend/modules/core/middleware/workspacesAndApplications.js"),
  pendingJobs: () => import("/baserow/web-frontend/modules/core/middleware/pendingJobs.js"),
  staff: () => import("/baserow/web-frontend/modules/core/middleware/staff.js"),
  aiProvidersFeatureFlag: () => import("/baserow/web-frontend/modules/core/middleware/aiProvidersFeatureFlag.js"),
  impersonate: () => import("/baserow/web-frontend/modules/core/middleware/impersonate.js"),
  urlCheck: () => import("/baserow/web-frontend/modules/core/middleware/urlCheck.js"),
  dashboardRedirect: () => import("/baserow/web-frontend/modules/core/middleware/dashboardRedirect.js"),
  redirectCompletedOnboarding: () => import("/baserow/web-frontend/modules/core/middleware/redirectCompletedOnboarding.js"),
  tableLoading: () => import("/baserow/web-frontend/modules/database/middleware/tableLoading.js"),
  selectWorkspaceDatabaseTable: () => import("/baserow/web-frontend/modules/database/middleware/selectWorkspaceDatabaseTable.js"),
  dashboardLoading: () => import("/baserow/web-frontend/modules/dashboard/middleware/dashboardLoading.js"),
  selectWorkspaceBuilderPage: () => import("/baserow/web-frontend/modules/builder/middleware/selectWorkspaceBuilderPage.js"),
  selectWorkspaceAutomationWorkflow: () => import("/baserow/web-frontend/modules/automation/middleware/selectWorkspaceAutomationWorkflow.js")
}